
 import { mapGetters,mapActions } from 'vuex'
export default {
  props: {
    image: {
      type: String,
    },
    text: {
      type: String,
    },
    link: {
      type: String,
    },
    button: {
      type: String,
    },
    modal: {
     default: '',
     type: String,
    }
  },
  data() {
    return {
      isActive: this.active !== ''
    }
  },
  computed: {
    ...mapGetters({
      activeModal : 'pages/getActiveModal',
    }),
  },
  methods:{
    ...mapActions({
        updateActiveModal: 'pages/updateActiveModal', // map `this.add()` to `this.$store.commit('increment')`
      }),
    updateModal(id){
      const newId = this.$nuxt.$options.filters.convertModal(id)
      this.updateActiveModal(newId)
      console.log('Active Modal: ',this.activeModal)

    }
  },
}
